import auth from "./auth";

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + auth.getToken(),
};

export default headers;
